import { Select } from '@chakra-ui/react';
import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import { RegulatoryRuleType } from '@services/appsync/types';
import { SubscriptionOffer } from '@services/appsync/types';
import React from 'react';

export const CampaignSelector: React.FC = () => {
  const { cashFlowOffers, selectedCashFlowCampaignId, setSelectedCashFlowCampaignId } = useInvestorAccountModel();

  if (!cashFlowOffers || cashFlowOffers.length === 0) {
    return <Select isDisabled placeholder="Loading..." />;
  }

  const getOfferLabel = (offer: SubscriptionOffer) =>
    offer.regulatory_rule_type === RegulatoryRuleType.REG_D_506C
      ? 'Cash Flow (Accredited Investors Only)'
      : 'Cash Flow (All Investors)';

  return (
    <Select value={selectedCashFlowCampaignId} onChange={(e) => setSelectedCashFlowCampaignId(e.target.value)}>
      {cashFlowOffers.map((offer) => (
        <option key={offer.id} value={offer.id}>
          {getOfferLabel(offer)}
        </option>
      ))}
    </Select>
  );
};
